module.exports = __webpack_public_path__ + "assets/img/ty3.75167568.jpg";